module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.texas.gov"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
